export default __webpack_public_path__ + "static/media/CHECK_ICONA_24.d326637a.svg";